import {
  ChartVisualizationData,
  LineValueData
} from "@repo/core/components/chart/ReportCharts/types";
import {
  TableDataRow,
  TableHeaderData
} from "@repo/core/components/core/DataTable/types";
import { ReportCardProps } from "../../components/ReportCard/types";
import { ReportCardEnum } from "@repo/core/types/reports";

export const overdueWalletReportChartData: ChartVisualizationData[] = [
  {
    color: "#08A282",
    name: "A Receber",

    visualizationData: [
      {
        label: "01/10/2024",
        value: 700
      },
      {
        label: "05/10/2024",
        value: 730
      },
      {
        label: "11/10/2024",
        value: 720
      },
      {
        label: "15/10/2024",
        value: 750
      },
      {
        label: "21/10/2024",
        value: 740
      }
    ]
  },
  {
    color: "#E74C3C",
    name: "Em Aberto",
    visualizationData: [
      {
        label: "01/10/2024",
        value: 200
      },
      {
        label: "05/10/2024",
        value: 210
      },
      {
        label: "11/10/2024",
        value: 205
      },
      {
        label: "15/10/2024",
        value: 220
      },
      {
        label: "21/10/2024",
        value: 215
      }
    ]
  }
];
export const overdueWalletReportBarLineData: LineValueData = {
  name: "% Em Aberto",
  color: "#000000",
  values: [
    {
      value: 350
    },
    {
      value: 380
    },
    {
      value: 370
    },
    {
      value: 380
    },
    {
      value: 380
    }
  ]
};
export const overdueWalletReportTableHeaders: TableHeaderData[] = [
  {
    key: "dueDate",
    label: "Vencimento",
    styles: {
      text: {
        color: "$secondary700",
        fontWeight: 500
      },
      containerClass: "h-4 justify-center"
    }
  },
  {
    key: "totalToReceive",
    label: "Total a Receber (R$)",
    styles: {
      text: {
        color: "$primary700",
        fontWeight: 500
      },
      containerClass: "h-4 justify-center"
    }
  },
  {
    key: "totalOpen",
    label: "Total Em Aberto (R$)",
    styles: {
      text: {
        color: "$primary700",
        fontWeight: 500
      },
      containerClass: "h-4 justify-center"
    }
  },
  {
    key: "percentOpen",
    label: "% Em Aberto",
    styles: {
      text: {
        color: "$error700",
        fontWeight: 500
      },
      containerClass: "h-4 justify-center"
    }
  }
];
export const overdueWalletReportTableData: TableDataRow[] = [
  {
    className: "bg-light-50",
    values: {
      dueDate: {
        value: "01/10/2024"
      },
      totalToReceive: {
        value: "R$58.352,25"
      },
      totalOpen: {
        value: "R$8.458,17"
      },
      percentOpen: {
        value: "14,5%"
      }
    }
  },
  {
    className: "bg-light-0",
    values: {
      dueDate: {
        value: "05/10/2024"
      },
      totalToReceive: {
        value: "R$101.697,40"
      },
      totalOpen: {
        value: "R$13.602,95"
      },
      percentOpen: {
        value: "13,4%"
      }
    }
  },
  {
    className: "bg-light-50",
    values: {
      dueDate: {
        value: "11/10/2024"
      },
      totalToReceive: {
        value: "R$242.099,42"
      },
      totalOpen: {
        value: "R$33.403,17"
      },
      percentOpen: {
        value: "13,8%"
      }
    }
  },
  {
    className: "bg-light-0",
    values: {
      dueDate: {
        value: "15/10/2024"
      },
      totalToReceive: {
        value: "R$210.387,28"
      },
      totalOpen: {
        value: "R$39.271,54"
      },
      percentOpen: {
        value: "18,7%"
      }
    }
  },
  {
    className: "bg-light-50",
    values: {
      dueDate: {
        value: "21/10/2024"
      },
      totalToReceive: {
        value: "R$137.273,80"
      },
      totalOpen: {
        value: "R$28.707,09"
      },
      percentOpen: {
        value: "20,9%"
      }
    }
  },
  {
    className: "bg-light-0",
    values: {
      dueDate: {
        value: "25/10/2024"
      },
      totalToReceive: {
        value: "R$203.219,44"
      },
      totalOpen: {
        value: "R$44.856,93"
      },
      percentOpen: {
        value: "22,1%"
      }
    }
  },
  {
    className: "bg-light-50 border-0 border-t-2 border-secondary-300",
    values: {
      dueDate: {
        value: "Total",
        styles: {
          color: "$secondary700",
          fontWeight: 600
        }
      },
      totalToReceive: {
        value: "R$953.029,59"
      },
      totalOpen: {
        value: "R$168.299,85"
      },
      percentOpen: {
        value: "17,7%"
      }
    }
  }
];

export const mockedAnalysedProposalsReport: {
  reportType: ReportCardEnum;
  cards: Omit<ReportCardProps, "variant">[];
} = {
  reportType: ReportCardEnum.ANALYSED_PROPOSALS,
  cards: [
    {
      period: "Agosto 2024",
      bgColor: "$backgroundLight50",
      values: [
        {
          label: "Taxa de Aprovação",
          value: "36%",
          styles: {
            showIndicator: true,
            indicatorColor: "#61BF61"
          }
        }
      ],
      propsByVariant: {
        [ReportCardEnum.ANALYSED_PROPOSALS]: {
          totalAnalysed: "1.100",
          totalApproved: "400",
          totalNegated: "700",
          totalApprovedEffective: "300",
          activatedAccounts: "100"
        }
      }
    },
    {
      period: "Setembro 2024",
      bgColor: "$backgroundLight0",
      values: [
        {
          label: "Taxa de Aprovação",
          value: "36%",
          styles: {
            showIndicator: true,
            indicatorColor: "#61BF61"
          }
        }
      ],
      propsByVariant: {
        [ReportCardEnum.ANALYSED_PROPOSALS]: {
          totalAnalysed: "1.236",
          totalApproved: "445",
          totalNegated: "791",
          totalApprovedEffective: "300",
          activatedAccounts: "100"
        }
      }
    },
    {
      period: "Outubro 2024",
      bgColor: "$backgroundLight50",
      values: [
        {
          label: "Taxa de Aprovação",
          value: "36%",
          styles: {
            showIndicator: true,
            indicatorColor: "#61BF61"
          }
        }
      ],
      propsByVariant: {
        [ReportCardEnum.ANALYSED_PROPOSALS]: {
          totalAnalysed: "1.500",
          totalApproved: "530",
          totalNegated: "970",
          totalApprovedEffective: "300",
          activatedAccounts: "100"
        }
      }
    }
  ]
};
